// reacttour/TourButton.js - the ❓ button that replays a page's walkthrough (StudioTours.js)
import React, { useState } from "react";
import { useStudioTours } from "./StudioTourContext";
import { tourButton } from "../styles/index";

export default function TourButton({ tour, context, label = "❓", title = "Show me around" }) {
  const [hover, setHover] = useState(false);
  const { startTour } = useStudioTours();

  return (
    <button
      type="button"
      title={title}
      aria-label={title}
      onClick={() => startTour(tour, typeof context === "function" ? context() : context)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={hover ? { ...tourButton.base, ...tourButton.hover } : tourButton.base}
    >
      {label}
    </button>
  );
}
